import { render, staticRenderFns } from "./ProfileContainer.vue?vue&type=template&id=509c5539&"
import script from "./ProfileContainer.vue?vue&type=script&lang=js&"
export * from "./ProfileContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports